import gql from 'graphql-tag';

const FRAGMENT = gql`
  fragment Campaign on campaigns {
    id
    created_at
    delivery_at
    delivery_type
    name
    message
    ran_at
    recipients
    user {
      user_first_name
      user_last_name
      user_preferred_name
    }
  }
`;

export const GET_CAMPAIGNS = gql`
  query getCampaigns {
    campaigns(order_by: { delivery_at: desc }) {
      ...Campaign
    }
  }
  ${FRAGMENT}
`;

export const ADD_CAMPAIGN = gql`
  mutation addCampaign($data: campaigns_insert_input!) {
    insert_campaigns_one(object: $data) {
      ...Campaign
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_CAMPAIGN = gql`
  mutation updateCampaign($id: Int!, $data: campaigns_set_input!) {
    update_campaigns_by_pk(pk_columns: { id: $id }, _set: $data) {
      ...Campaign
    }
  }
  ${FRAGMENT}
`;

export const DELETE_CAMPAIGN = gql`
  mutation deleteCampaign($id: Int!) {
    delete_campaigns_by_pk(id: $id) {
      id
    }
  }
`;

export const SUBSCRIBE_GET_USERS = gql`
  subscription getUsers {
    users(
      where: { 
          user_type: { _in: ["student"] }
      }
      order_by: [{ name: asc }, { user_last_name: asc }]
    ) {
      user_id
      name
      user_last_name
      user_type
      student_guardians {
          guardian {
              user_id
              name
              user_last_name
              notifications_settings(where: { topic: { _eq: "CAMPAIGN_MESSAGES" } }) {
                  id
                  sms
                  email
              }
          }
      }  
      notifications_settings(where: { topic: { _eq: "CAMPAIGN_MESSAGES" } }) {
        id
        sms
        email
      }
    }
  }
`;

export const GET_USERS = gql`
    query getUsers {
        users(
            where: {
                user_type: { _in: ["parent", "student"] }
            }
            order_by: [{ user_first_name: asc }, { user_last_name: asc }]
        ) {
            user_id
            user_preferred_name
            user_first_name
            user_last_name
            user_type
        }
    }
`;

export const UPDATE_COMM_SETTINGS = gql`
  mutation update($userId: Int!, $opted: Boolean!) {
    insert_notifications_settings_one(
      object: {
        user_id: $userId
        email: $opted
        sms: $opted
        topic: "CAMPAIGN_MESSAGES"
      }
      on_conflict: {
        constraint: notifications_settings_user_id_topic_key
        update_columns: [sms, email]
      }
    ) {
        id
        email
        sms
        user_id
    }
  }
`;
